<template>
  <div :class="classList" role="button" @click="$emit('click')">
    <img :src="imgArrow" width="23" alt="arrow" />
  </div>
</template>

<script>
import imgLeft from "@/assets/arrow-left.png";
import imgRight from "@/assets/arrow-right.png";

export default {
  name: "ArrowButton",
  props: {
    left: Boolean
  },
  computed: {
    classList() {
      return {
        "arrow-button": true,
        "arrow-button-left": this.left,
        "arrow-button-right": !this.left
      };
    },
    imgArrow() {
      if (this.left) {
        return imgLeft;
      }

      return imgRight;
    }
  }
};
</script>

<style scoped lang="scss">
.arrow-button {
  width: 51px;
  height: 51px;
  border-radius: 50%;
  background-color: #474c55;
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    width: 23px;
  }

  &-left {
    left: -81px;
  }
  &-right {
    right: -81px;
  }
}

@media screen and (max-width: 960px) {
  .arrow-button {
    width: 34px;
    height: 34px;
    z-index: 2;

    > img {
      width: 15px;
    }

    &-left {
      left: -10px;
    }

    &-right {
      right: -10px;
    }
  }
}
</style>
